import axios from '../axios';

/**
 * 分页获取自己的项目-项目管理
 * 
 * @url /ent_tech_research_development/index
 * 
 */

export function researchprojects(params) {
    return axios.post('/ent_tech_research_development/index', params)
}
/**
 * 获取自己的项目详情-项目管理
 * 
 * @url /ent_tech_research_development/detail
 * 
 */

export function Projectdetail(params) {
    return axios.post('/ent_tech_research_development/detail', params)
}
/**
 * 获取自己的项目附件-项目管理
 * 
 * @url /ent_tech_research_development/file_list
 * 
 */

export function enttechresearchdevelopmentfilelist(params) {
    return axios.post('/ent_tech_research_development/file_list', params)
}
/**
 * 项目附件删除-项目管理
 * 
 * @url /ent_tech_research_development/remove_file
 * 
 */

export function enttechresearchdevelopmentremovefile(params) {
    return axios.post('/ent_tech_research_development/remove_file', params)
}
/**
 * 项目计划与进度任务
 * 
 * @url /project_task/index
 * 
 */

export function projecttaskindex(params) {
    return axios.post('/project_task/index', params)
}

/**
 * 项目关联值
 * 
 * @url /ent_tech_research_development/modify_value
 * 
 */

export function enttechresearchdevelopmentmodifyvalue(params) {
    return axios.post('/ent_tech_research_development/modify_value', params)
}

/**
 * 获取项目修改-项目管理
 * 
 * @url /ent_design/detail
 * 
 */

export function designDetail(params) {
    return axios.post('/ent_tech_research_development/update', params)
}
/**
 * 项目添加-项目新增
 * 
 * @url /ent_design/save
 * 
 */

export function designSave(params) {
    return axios.post('/ent_tech_research_development/save', params)
}
/**
 * 项目添加-行业信息
 * 
 * @url /ent_tech_research_development/industry
 * 
 */

export function developmentindustry(params) {
    return axios.post('/ent_tech_research_development/industry', params)
}

/**
 *添加人员-项目管理
 * 
 * @url /ent_tech_research_development/add_project_user
 * 
 */

export function pipoSearch(params) {
    return axios.post('/ent_tech_research_development/add_project_user', params)
}
/**
 *人员清单-项目管理
 * 
 * @url /ent_tech_research_development/user_list
 * 
 */

export function pipoList(params) {
    return axios.post('/ent_tech_research_development/user_list', params)
}
/**
 *移出项目人员-项目管理
 * 
 * @url /ent_tech_research_development/remove_project_user
 * 
 */

export function outpipo(params) {
    return axios.post('/ent_tech_research_development/remove_project_user', params)
}
/**
 * 项目删除-项目管理
 * 
 * @url /ent_tech_research_development/delete
 * 
 */

export function designDelete(params) {
    return axios.post('/ent_tech_research_development/delete', params)
}
/**
 * 修改角色及权重
 * 
 * @url /ent_tech_research_development/edit_project_user
 * 
 */

export function enttechresearchdevelopmenteditprojectuser(params) {
    return axios.post('/ent_tech_research_development/edit_project_user', params)
}


/**
 * 预算与使用
 * 
 * @url /ent_rd_fee/total
 * 
 */

export function entrdfeetotal(params) {
    return axios.post('/ent_rd_fee/total', params)
}
/**
 * 修改预算
 * 
 * @url /ent_rd_fee/modify_plan
 * 
 */

export function entrdfeemodifyplan(params) {
    return axios.post('/ent_rd_fee/modify_plan', params)
}



/**
 * 分页获取自己的项目-技术监控
 * 
 * @url /ent_tech_monitor/index
 * 
 */

export function Technicalmonitoring(params) {
    return axios.post('/ent_tech_monitor/index', params)
}
/**
 * 分页获取自己的项目-取消监控
 * 
 * @url /ent_tech_monitor/delete
 * 
 */

export function enttechmonitordelete(params) {
    return axios.post('/ent_tech_monitor/delete', params)
}
/**
 * 分页获取自己的项目-添加监控
 * 
 * @url /ent_tech_monitor/save
 * 
 */

export function enttechmonitorsave(params) {
    return axios.post('/ent_tech_monitor/save', params)
}
/**
 * 技术关键词检索
 * 
 * @url /patent/query_key
 * 
 */

export function patentquerykey(params) {
    return axios.post('/patent/query_key', params)
}
/**
 * 技术关键词检索详情
 * 
 * @url /patent/detail
 * 
 */

export function patentdetail(params) {
    return axios.post('/patent/detail', params)
}
/**
 * 分页获取报告-技术监控
 * 
 * @url /ent_tech_monitor/report
 * 
 */

export function Navigationreport(params) {
    return axios.post('/ent_tech_monitor/report', params)
}
/**
 * 分页获取商标报告
 * 
 * @url /ent_tech_monitor/report
 * 
 */

export function trademarkReport(params) {
    return axios.post('/trademark_trusteeship/report', params)
}
/**
 * 获取商标报告详情
 * 
 * @url /ent_tech_monitor/report
 * 
 */

export function trademarkDetail(params) {
    return axios.post('/trademark_trusteeship/detail', params)
}
/**
 * 获取政策
 * 
 * @url /policy/index?page=
 * 
 */

export function policyList(params) {
    return axios.post('/policy/index?page=', params)
}

/**
 * 获取企业政策匹配结果
 * 
 * @url /policy/match_result
 * 
 */

export function policymatchresult(params) {
    return axios.post('/policy/match_result', params)
}
/**
 * 获取我订阅的政策
 * 
 * @url policy/my_follow
 * 
 */

export function policymyfollow(params) {
    return axios.post('/policy/my_follow', params)
}
/**
 * 共享订阅政策给企业
 * 
 * @url /policy/share
 * 
 */

export function policyshare(params) {
    return axios.post('/policy/share', params)
}
/**
 * 获取政策详情
 * 
 * @url /policy/detail
 * 
 */

export function policydetail(params) {
    return axios.post('/policy/detail', params)
}
/**
 * 取消政策订阅
 * 
 * @url /policy/remove
 * 
 */

export function policyunsubscribe(params) {
    return axios.post('/policy/remove', params)
}
/**
 * 政策订阅
 * 
 * @url /policy/follow
 * 
 */

export function policySubscribe(params) {
    return axios.post('/policy/follow', params)
}
/**
 * 政策企业瞭望台
 * 
 * @url /policy/ent_follow
 * 
 */

export function policyentfollow(params) {
    return axios.post('/policy/ent_follow', params)
}
/**
 * 融资项目清单
 * 
 * @url /ent_finance/index
 * 
 */

export function financeindex(params) {
    return axios.post('/ent_finance/index', params)
}
/**
 * 新增融资项目
 * 
 * @url /ent_finance/save
 * 
 */

export function financesave(params) {
    return axios.post('/ent_finance/save', params)
}
/**
 * 更新融资项目
 * 
 * @url /ent_finance/update
 * 
 */

export function financeupdate(params) {
    return axios.post('/ent_finance/update', params)
}
/**
 * 取消融资项目
 * 
 * @url /ent_finance/delete
 * 
 */

export function financedelete(params) {
    return axios.post('/ent_finance/delete', params)
}
/**
 * 贷款项目清单
 * 
 * @url /ent_loan/index
 * 
 */

export function loanindex(params) {
    return axios.post('/ent_loan/index', params)
}
/**
 * 新增贷款项目
 * 
 * @url /ent_loan/save
 * 
 */

export function loansave(params) {
    return axios.post('/ent_loan/save', params)
}
/**
 * 更新贷款项目
 * 
 * @url /ent_finance/update
 * 
 */

export function financesupdate(params) {
    return axios.post('/ent_loan/update', params)
}
/**
 * 取消贷款项目
 * 
 * @url /ent_finance/delete
 * 
 */

export function financesdelete(params) {
    return axios.post('/ent_loan/delete', params)
}

/**
 * echarts图表数据
 * 
 * @url /ent/grade
 */

export function entgrade(params) {
    return axios.post('/ent/grade', params)
}
/**
 * 
 * @url /me
 */

export function me(params) {
    return axios.post('/auth/me', params)
}
// 获取政策匹配度
/**
 * 
 * @url /policy/get_result
 */

export function policygetresult(params) {
    return axios.post('/policy/get_result', params)
}

// 产品管理

// 分页获取产品
/**
 * 
 * @url /ent_product/index
 */

export function entproductindex(params) {
    return axios.post('/ent_product/index', params)
}
// 新增产品
/**
 * 
 * @url /ent_product/save
 */

export function entproductsave(params) {
    return axios.post('/ent_product/save', params)
}
// 新增产品分类
/**
 * 
 * @url /ent_product/cate
 */

export function entproductcate(params) {
    return axios.post('/ent_product/cate', params)
}
// 删除产品
/**
 * 
 * @url /ent_product/delete
 */

export function entproductdelete(params) {
    return axios.post('/ent_product/delete', params)
}
// 删除产品文件
/**
 * 
 * @url /ent_product/delete_file
 */

export function entproductdeletefile(params) {
    return axios.post('/ent_product/delete_file', params)
}
// 设为封面
/**
 * 
 * @url /ent_product/set_picture
 */

export function entproductsetpicture(params) {
    return axios.post('/ent_product/set_picture', params)
}

// 产品详情
/**
 * 
 * @url /ent_product/detail
 */

export function entproductdetail(params) {
    return axios.post('/ent_product/detail', params)
}
// 产品修改更新
/**
 * 
 * @url /ent_product/update
 */

export function entproductupdate(params) {
    return axios.post('/ent_product/update', params)
}
// 加入瞭望台-专利
/**
 * 
 * @url /follow_patent/follow
 */

export function followpatentfllow(params) {
    return axios.post('/follow_patent/follow', params)
}
// 加入瞭望台-商标
/**
 * 
 * @url /follow_trademark/follow
 */

export function followtrademarkfllow(params) {
    return axios.post('/follow_trademark/follow', params)
}

// 成果管理
/**
 * 
 * @url /ent_achievements/index
 */

export function entachievementsindex(params) {
    return axios.post('/ent_achievements/index', params)
}
// 成果管理新增
/**
 * 
 * @url /ent_achievements/save
 */

export function entachievementssave(params) {
    return axios.post('/ent_achievements/save', params)
}
// 成果管理修改
/**
 * 
 * @url /ent_achievements/update
 */

export function entachievementsupdate(params) {
    return axios.post('/ent_achievements/update', params)
}
// 成果管理详情
/**
 * 
 * @url /ent_achievements/detail
 */

export function entachievementsdetail(params) {
    return axios.post('/ent_achievements/detail', params)
}
// 成果管理附件新增
/**
 * 
 * @url /ent_achievements/add_item
 */

export function entachievementsadditem(params) {
    return axios.post('/ent_achievements/add_item', params)
}
// 成果管理附件删除
/**
 * 
 * @url /ent_achievements/remove_item
 */

export function entachievementsremoveitem(params) {
    return axios.post('/ent_achievements/remove_item', params)
}
// 成果管理删除
/**
 * 
 * @url /ent_achievements/delete
 */

export function entachievementsdelete(params) {
    return axios.post('/ent_achievements/delete', params)
}
// 分页获取合同
/**
 * 
 * @url /ent_contract/index
 */

export function entcontractindex(params) {
    return axios.post('/ent_contract/index', params)
}

// 合同详情
/**
 * 
 * @url /ent_contract/detail
 */

export function entcontractdetail(params) {
    return axios.post('/ent_contract/detail', params)
}
// 合同删除
/**
 * 
 * @url /ent_contract/delete
 */

export function entcontractdelete(params) {
    return axios.post('/ent_contract/delete', params)
}
// 合同新增
/**
 * 
 * @url /ent_contract/save
 */

export function entcontractsave(params) {
    return axios.post('/ent_contract/save', params)
}
// 合同修改
/**
 * 
 * @url /ent_contract/update
 */

export function entcontractupdate(params) {
    return axios.post('/ent_contract/update', params)
}

/**
 *订单-管家合同
 * 
 * @url /company/orders
 * 
 */

export function companyorders(params) {
    return axios.post('/company/orders', params)
}

/**
 *ipc分类检索
 * 
 * @url /patent/level_data
 * 
 */

export function patentleveldata(params) {
    return axios.post('/patent/level_data', params)
}